import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDbIyS7NHKkUl2uOLaESLw8HlWCNj8cTwA",
  authDomain: "just-vibes-99d61.firebaseapp.com",
  databaseURL: "https://just-vibes-99d61-default-rtdb.firebaseio.com",
  projectId: "just-vibes-99d61",
  storageBucket: "just-vibes-99d61.firebasestorage.app",
  messagingSenderId: "795969527413",
  appId: "1:795969527413:web:104bc168ba50378289e23c",
  measurementId: "G-50BQKE1ZF2"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const storage = getStorage(app);

export { app, analytics, storage }; 